import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

type CardComponentProps = {
	title: ReactNode;
	children: ReactNode;
	footerActionItems?: ReactNode[];
	styles?: {
		cardContainerStyles?: {
			marginTop?: string;
		};
	};
};

type FooterActionItemProps = {
	items: ReactNode[];
};

export const FooterActionItems = ({ items }: FooterActionItemProps) => (
	<>
		{items.map((item, index) => (
			<FooterActionItemContainer key={index}>{item}</FooterActionItemContainer>
		))}
	</>
);

export const SettingsCardComponent = ({
	title,
	children,
	footerActionItems,
	styles = {},
}: CardComponentProps) => {
	const Title = typeof title === 'string' ? <h4>{title}</h4> : title;

	return (
		<CardContainer {...styles.cardContainerStyles}>
			{Title}
			<BodyWrapper>{children}</BodyWrapper>
			{footerActionItems && (
				<Box xcss={footerContainerStyles}>
					<FooterActionItems items={footerActionItems} />
				</Box>
			)}
		</CardContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CardContainer = styled.div<{ marginTop?: string }>({
	padding: token('space.300', '24px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	border: `1px solid ${token('color.border', colors.N40)}`,
	borderRadius: '5px',
	overflow: 'hidden',
	// We're passing styles through from who knows where. Future rewrite territory

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginTop: ({ marginTop }) => marginTop,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BodyWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: `${token('color.text', colors.N700)}`,
	marginTop: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FooterActionItemContainer = styled.div({
	display: 'inline-block',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':not(:first-of-type)': {
		marginLeft: token('space.100', '8px'),
	},
});

const footerContainerStyles = xcss({
	marginTop: 'space.200',
});
